export default ".pointer {\n  cursor: pointer;\n}\n\n:host {\n  display: flex;\n}"